const u = (n) => {
  const s = new Date(0, 0, 0, 0, 0), { hours: o, minutes: t, seconds: e } = c(n);
  return s.setHours(Number(o)), s.setMinutes(Number(t)), s.setSeconds(Number(e)), s;
}, m = (n) => {
  const s = n.getHours(), o = n.getMinutes(), t = n.getSeconds();
  return s * 3600 + o * 60 + t;
}, r = (n) => {
  const s = Math.floor(n / 3600), o = Math.floor(n % 3600 / 60);
  return {
    hours: s < 10 ? `0${s}` : String(s),
    minutes: o < 10 ? `0${o}` : String(o)
  };
}, c = (n) => {
  const { hours: s, minutes: o } = r(n), t = n % 60;
  return {
    hours: s,
    minutes: o,
    seconds: t < 10 ? `0${t}` : String(t)
  };
};
export {
  m as transformDateToSeconds,
  u as transformSecondsToDate,
  r as transformSecondsToHoursAndMinutes,
  c as transformSecondsToHoursMinutesSeconds
};
